export { default } from "./TextFrame";
